/**
 * @desc 分页
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.stockAdjustmentMaster.pageList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stockAdjustmentMaster/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
